import {Endpoints} from '../../globals/api/endpoints';

export class FileEndpoints extends Endpoints {
  public static readonly FILES_LIST = Endpoints.VIEWER + '/file-list/' + FileEndpoints.PROJECT_ID;
}
